import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1bb650dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { colspan: "10" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "费用信息", -1))
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { colspan: "10" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "成本信息", -1))
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { colspan: "10" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "业务员结算价", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_miezz_page_list = _resolveComponent("miezz-page-list")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.hideCosts)
      ? (_openBlock(), _createElementBlock("tr", _hoisted_1, [
          _createElementVNode("td", _hoisted_2, [
            _hoisted_3,
            _createVNode(_component_miezz_page_list, {
              modelValue: _ctx.listCosts,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.listCosts) = $event))
            }, {
              column: _withCtx(({ model, row, index }) => [
                (model.Prop == 'CostId')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      prop: `Costs[${index}].${model.Prop}`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.CostLabel ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'CurrencySystemId')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 1,
                      prop: `Costs[${index}].${model.Prop}`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.CurrencySystemLabel ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'UnitPrice')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 2,
                      prop: `Costs[${index}].${model.Prop}`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.UnitPrice ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'TaxRate')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 3,
                      prop: `Costs[${index}].${model.Prop}`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.TaxRate ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'FirstChargingUnitId')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 4,
                      prop: `Costs[${index}].${model.Prop}`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.FirstChargingUnitLabel ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'FirstChargingNumber')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 5,
                      prop: `Costs[${index}].${model.Prop}`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.FirstChargingNumber ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'SecondChargingUnitId')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 6,
                      prop: `Costs[${index}].${model.Prop}`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.SecondChargingUnitLabel ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'SecondChargingNumber')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 7,
                      prop: `Costs[${index}]`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.SecondChargingNumber ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'TaxAmount')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 8,
                      prop: `Costs[${index}].${model.Prop}`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.TaxAmount ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'TotalPrice')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 9,
                      prop: `Costs[${index}].${model.Prop}`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.TotalPrice ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'Remark')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 10,
                      prop: `Costs[${index}].${model.Prop}`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.Remark ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showSupplierCosts)
      ? (_openBlock(), _createElementBlock("tr", _hoisted_4, [
          _createElementVNode("td", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_miezz_page_list, {
              modelValue: _ctx.listSupplierCosts,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.listSupplierCosts) = $event))
            }, {
              column: _withCtx(({ model, row, index }) => [
                (model.Prop == 'PreSupplierLabel')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      prop: `SupplierCosts[${index}].${model.Prop}`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.PreSupplierLabel ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'CostId')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 1,
                      prop: `SupplierCosts[${index}].${model.Prop}`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.CostLabel ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'CurrencySystemId')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 2,
                      prop: `SupplierCosts[${index}].${model.Prop}`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.CurrencySystemLabel ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'UnitPrice')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 3,
                      prop: `SupplierCosts[${index}].${model.Prop}`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.UnitPrice ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'TaxRate')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 4,
                      prop: `SupplierCosts[${index}].${model.Prop}`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.TaxRate ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'FirstChargingUnitId')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 5,
                      prop: `SupplierCosts[${index}].${model.Prop}`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.FirstChargingUnitLabel ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'FirstChargingNumber')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 6,
                      prop: `SupplierCosts[${index}].${model.Prop}`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.FirstChargingNumber ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'SecondChargingUnitId')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 7,
                      prop: `SupplierCosts[${index}].${model.Prop}`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.SecondChargingUnitLabel ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'SecondChargingNumber')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 8,
                      prop: `SupplierCosts[${index}]`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.SecondChargingNumber ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'TaxAmount')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 9,
                      prop: `SupplierCosts[${index}].${model.Prop}`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.TaxAmount ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'TotalPrice')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 10,
                      prop: `SupplierCosts[${index}].${model.Prop}`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.TotalPrice ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'Remark')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 11,
                      prop: `SupplierCosts[${index}].${model.Prop}`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.Remark ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showSettlementCosts)
      ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
          _createElementVNode("td", _hoisted_8, [
            _hoisted_9,
            _createVNode(_component_miezz_page_list, {
              modelValue: _ctx.listSettlementCosts,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.listSettlementCosts) = $event))
            }, {
              column: _withCtx(({ model, row, index }) => [
                (model.Prop == 'CostId')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      prop: `SettlementCosts[${index}].${model.Prop}`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.CostLabel ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'CurrencySystemId')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 1,
                      prop: `SettlementCosts[${index}].${model.Prop}`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.CurrencySystemLabel ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'UnitPrice')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 2,
                      prop: `SettlementCosts[${index}].${model.Prop}`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.UnitPrice ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'TaxRate')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 3,
                      prop: `SettlementCosts[${index}].${model.Prop}`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.TaxRate ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'FirstChargingUnitId')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 4,
                      prop: `SettlementCosts[${index}].${model.Prop}`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.FirstChargingUnitLabel ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'FirstChargingNumber')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 5,
                      prop: `SettlementCosts[${index}].${model.Prop}`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.FirstChargingNumber ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'SecondChargingUnitId')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 6,
                      prop: `SettlementCosts[${index}].${model.Prop}`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.SecondChargingUnitLabel ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'SecondChargingNumber')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 7,
                      prop: `SettlementCosts[${index}]`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.SecondChargingNumber ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'TaxAmount')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 8,
                      prop: `SettlementCosts[${index}].${model.Prop}`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.TaxAmount ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'TotalPrice')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 9,
                      prop: `SettlementCosts[${index}].${model.Prop}`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.TotalPrice ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'Remark')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 10,
                      prop: `SettlementCosts[${index}].${model.Prop}`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.Remark ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}